export enum SectionIds {
  FAQ = 'FAQ-section',
  FirstSchemas = 'first-schemas-section',
  Benefits = 'benefits-section',
}
